import { create } from "zustand";

type SignInOptions = { title?: string; description?: string };
type SignInRequest = SignInOptions & {
  promise: Promise<boolean>;
  resolve: (signedIn: boolean) => void;
  trigger: HTMLElement | null;
};

export const useSignInDialog = create<{ request: SignInRequest | null }>(
  () => ({
    request: null,
  })
);

/** Opens the shared provider picker. Dismissal resolves false without starting sign-in. */
export function requestSignIn(options: SignInOptions = {}): Promise<boolean> {
  const existing = useSignInDialog.getState().request;
  if (existing) return existing.promise;
  let resolve!: SignInRequest["resolve"];
  const promise = new Promise<boolean>((complete) => {
    resolve = complete;
  });
  const request: SignInRequest = {
    ...options,
    promise,
    resolve,
    trigger:
      typeof document !== "undefined" &&
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null,
  };
  useSignInDialog.setState({ request });
  return promise;
}

/** Ignore completion from an already dismissed or replaced dialog. */
export function finishSignIn(request: SignInRequest, signedIn: boolean) {
  if (useSignInDialog.getState().request !== request) return;
  useSignInDialog.setState({ request: null });
  request.resolve(signedIn);
}
